import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
import THead from './THead';
interface IProps {
  moduleData: any;
  isView: boolean;
  partData: any;
}

const TController = ({ moduleData, isView, partData }: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            partData,
          }}
        />
        <TBody {...{ moduleData, partData, isView }} />
      </RenderTable>
    </Box>
  );
};

export default TController;
